export default "__VITE_ASSET__B$6IrQim__"